import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IVantaDisplayShotSetting } from '../interfaces/display-settings';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    constructor(private httpClient: HttpClient) { }

    public getSettings(): Promise<IVantaDisplayShotSetting> {
        return new Promise<IVantaDisplayShotSetting>((resolve, reject) => {
            this.httpClient.get<any>(`/api/displayOptionSettings`)
            .subscribe((settings) => {
                resolve(settings);
            }, (error) => {
                reject(error);
            });
        });
    }

    public addSettings(setting: IVantaDisplayShotSetting): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            this.httpClient.post<any>(`/api/displayOptionSettings`, setting)
            .subscribe(() => {
                resolve();
            }, (error) => {
                reject(error);
            });
        });
    }

    public updateSettings(setting: IVantaDisplayShotSetting): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            this.httpClient.put<any>(`/api/displayOptionSettings`, setting)
            .subscribe(() => {
                resolve();
            }, (error) => {
                reject(error);
            });
        });
    }
}
